import { Table } from '@themesberg/react-bootstrap'
import React from 'react'
import { formatDate } from '../../utils/dateFormatter'

const BonusDetailTable = ({
  bonusDetail,
  selectedBonus
}) => {
  return (
    <Table striped  className='text-start'>
      <thead>
        <tr className='thead-light text-center'>
          <th colSpan={2}>Bonus Details</th>
        </tr>
      </thead>
      {bonusDetail && bonusDetail?.bonusId === selectedBonus?.bonusId &&
        <tbody>
          <tr>
            <td>Promotion Title</td>
            <td>{bonusDetail?.promotionTitle?.EN}</td>
          </tr>
          <tr>
            <td>Bonus Type</td>
            <td>{bonusDetail?.bonusType}</td>
          </tr>
          {['match', 'deposit', 'wagering'].includes(bonusDetail?.bonusType) &&
            <tr>
              <td>Bonus Percentage</td>
              <td>{bonusDetail?.depositBonusPercent}%</td>
            </tr>}
          {['match', 'deposit', 'wagering'].includes(bonusDetail?.bonusType) &&
            <tr>
              <td>Sticky</td>
              <td>{bonusDetail?.isSticky ? 'Yes' : 'No'}</td>
            </tr>}
          {['match', 'deposit', 'wagering'].includes(bonusDetail?.bonusType) &&
            <tr>
              <td>Bonus Bet Only</td>
              <td>{bonusDetail?.bonusBetOnly ? 'Yes' : 'No'}</td>
            </tr>}
          {bonusDetail?.bonusType === 'freespins' &&
            <tr>
              <td>Quantity</td>
              <td>{bonusDetail?.quantity}</td>
            </tr>}
          {bonusDetail?.validFrom &&
            <tr>
              <td>Valid From</td>
              <td>{formatDate(bonusDetail?.validFrom)}</td>
            </tr>}
          {bonusDetail?.validTo &&
            <tr>
              <td>Valid To</td>
              <td>{formatDate(bonusDetail?.validTo)}</td>
            </tr>}
          <tr>
            <td>Days To Clear</td>
            <td>{bonusDetail?.daysToClear}</td>
          </tr>
          {(bonusDetail?.wageringMultiplier !== 0) &&
            <tr>
              <td>Wagering Type</td>
              <td>{bonusDetail?.wageringRequirementType}</td>
            </tr>}
          {(bonusDetail?.wageringMultiplier !== 0) &&
            <tr>
              <td>Wagering Multiplier</td>
              <td>{bonusDetail?.wageringMultiplier}</td>
            </tr>}
        </tbody>}
    </Table>
  )
}

export default BonusDetailTable
